<ion-header class="ion-no-border">
  <ion-toolbar color="success">
    <ion-buttons slot="end">
      <core-select-language></core-select-language>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" scroll-y="false">
  <div class="main-container container">
    <div class="logo-section">
      <div class="logo-wrapper">
        <ion-img src="assets/welcome-image.png" class="logo-img"></ion-img>
      </div>
    </div>

    <div class="bottom-section">
      <div class="secondary-logo">
        <ion-img src="assets/welcome-logo.png"></ion-img>
      </div>

      <div>
        <h1 [innerHTML]="'app#city_card#welcome#title' | translate"></h1>
        <p>{{ 'app#city_card#welcome#description' | translate }}</p>
      </div>

      <ion-button expand="block" color="primary" (click)="getStarted()">
        {{ 'app#city_card#welcome#get_started' | translate }}
      </ion-button>

      <ion-button expand="block" color="primary" fill="outline" (click)="getStarted()">
        {{ 'app#city_card#welcome#scan_code' | translate }}
      </ion-button>

      <ion-button expand="block" color="primary" fill="clear" (click)="getStarted()">
        {{ 'app#city_card#welcome#add_later' | translate }}
      </ion-button>
    </div>
  </div>
</ion-content>
